module.exports = __webpack_public_path__ + "static/Wedding_Build_My_Book-33e61e51cba306c982db651ce3bce350.jpg";